import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import "./App.css";
import ElementorContainer from "./containers/ElementorContainer";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/:hash" component={ElementorContainer} />
      </Switch>
    </Router>
  );
}

export default App;
